import './styles/splitPage.style.sass';
/**
 * Displays your left and right component in 35/65 cols
 * The left component will not be visible on mobile
 */
const SplitPage = ({ leftComponent, rightComponent }: { leftComponent: JSX.Element, rightComponent: JSX.Element }) => {
    return (
        <div className="split">
            <div className="split--left">{leftComponent}</div>
            <div className="split--right">{rightComponent}</div>
        </div>
    )
}
export default SplitPage
